import API from "./API";
import { sessionRenewApi } from "./sessionRenewApi";

export const tempInfo = async (payload) => {
  try {
    return await API.post("/weather/get_area_info", payload);
  } catch (error) {
     if (error.response && error.response.status === 403) {
      await sessionRenewApi();
      return API.post("/weather/get_area_info", payload);
    }
    throw error;
  }
};

